import { useState, useEffect } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HistoryTable from "./HistoryTable";
import useLogout from "../../hooks/useLogout";
import { useNavigate } from "react-router-dom";

const History = () => {
    const logout = useLogout();
    const [ticketDetails, setTicketDetails] = useState(false);
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
 
    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();

        const getRecentEscalations = async () => {
            try {
                const response = await axiosPrivate.get(`/report/history?project=last_ten_escalations`, {
                    signal: controller.signal
                });
                if(response.data.msg) return setTicketDetails(false)
                isMounted && setTicketDetails(response.data);
            } catch (err) {
                if(err.message !== 'canceled'){
                    await logout();
                    navigate('/login')
                }
            }
        }

        getRecentEscalations();

        return () => {
            isMounted = false;
            controller.abort();
        }
        // eslint-disable-next-line
    }, [])
  return (
    <HistoryTable ticketDetails={ticketDetails} setTicketDetails={setTicketDetails}/>
  )
}

export default History
